// src/context/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../firebase/config";
import { getUserProfile } from "../firebase/services";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);   // Firebase Auth user
  const [profile, setProfile] = useState(null);   // Firestore profile { role, name, ... }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        const p = await getUserProfile(firebaseUser.uid);
        setProfile(p);
      } else {
        setUser(null);
        setProfile(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  const login = (email, password) =>
    signInWithEmailAndPassword(auth, email, password);

  const logout = () => signOut(auth);

  // Role helpers
  const isAdmin     = profile?.role === "admin";
  const isHR        = profile?.role === "hr" || isAdmin;
  const isPrincipal = profile?.role === "principal" || isAdmin;
  const canEdit     = isHR || isPrincipal;
  const canDelete   = isAdmin;
  const canManageUsers = isAdmin;

  return (
    <AuthContext.Provider value={{
      user, profile, loading,
      login, logout,
      isAdmin, isHR, isPrincipal,
      canEdit, canDelete, canManageUsers
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
